/* eslint-disable camelcase */
import PropTypes from 'prop-types';

export const MediaModel = {
  original_image: PropTypes.string,
  small_image: PropTypes.string,
  medium_image: PropTypes.string,
  large_image: PropTypes.string
};
